export class Validator {
    static validateLogin(email: string, password: string, setError: (msg: string) => void): boolean {
      
      if (!email || !password) {
        setError("Please fill in all fields.");
        return false;
      }
  
      if (!/^\S+@\S+\.\S+$/.test(email)) {
        setError("Invalid email address.");
        return false;
      }
  
      if (password.length < 6) {
        setError("Password must be at least 6 characters.");
        return false;
      }
  
      return true;
    }
  
    static validateRegister(
      email: string,
      password: string,
      confirmPassword: string,
      setError: (msg: string) => void
    ): boolean {
      if (!this.validateLogin(email, password, setError)) return false;
  
      if (password !== confirmPassword) {
        setError("Passwords do not match.");
        return false;
      }
  
      return true;
    }
  }
  